import { RequestHelper,IResponse,IResponseWithData } from "../libs/request-helper";
import {MagazineReuestDto} from "../dtos/magazine-home-request-dto";
import { MagazineHomeResponseDto } from "../dtos/magazine-home-response-dto";
import {MagazineEntryDto} from "../dtos/magazine-entry-dto";
import {ItemRender} from "../renderer/magazine/item-renderer"
import {ErrorRenderer} from "../renderer/error-renderer";
import {ImageOverlayHelper} from "../libs/image-overlay-helper";

declare var Hyphenator:any;


export class Magazine2 {

	protected static requestUrl = "/wp-content/themes/enfold-schauspielhaus/json/magazine2.php";
	protected static ERROR_MSG = "Es konnten leider keine Magazineinträge gefunden werden!";

	protected static dataContainer: HTMLElement;
	protected static itemRenderer: ItemRender;
	protected static isLoading: boolean = false;
	protected static requestDto: MagazineReuestDto;
	protected static errorRenderer: ErrorRenderer;

	public static async init(): Promise<void> {
		Magazine2.dataContainer = <HTMLElement>document.getElementById("p_homeData");
		Magazine2.errorRenderer = new ErrorRenderer(Magazine2.dataContainer, Magazine2.ERROR_MSG);
		document.addEventListener('DOMContentLoaded', Magazine2.onDocumentLoaded, false);
	}

	protected static onDocumentLoaded() {
		Magazine2.requestDto = new MagazineReuestDto();
		Magazine2.requestDto.isHome = true;
		Magazine2.requestDto.shouldLimited = false;
		Magazine2.loadData();
	}

	protected static renderHero(hero: MagazineEntryDto) {
		var heroWrapper = document.createElement("div");
		heroWrapper.classList.add("sshgWidget_heroTeaser");
		Magazine2.dataContainer.appendChild(heroWrapper);
		var heroRenderer = new ItemRender(heroWrapper,true);
		heroRenderer.render(hero);
	}

	protected static appendData(data: MagazineEntryDto[]) {
		if(data.length > 0){

			var magazineContainer = document.createElement("div");
			magazineContainer.classList.add("_magazineHomeContainer");
			Magazine2.dataContainer.appendChild(magazineContainer);
			Magazine2.itemRenderer = new ItemRender(magazineContainer);
		
			for (var i = 0; i < data.length; i++) {
				Magazine2.itemRenderer.render(data[i]);
			}
		}
		Hyphenator.run();
	}

	protected static async loadData() {
		if (!Magazine2.isLoading) {
			Magazine2.isLoading = true;
			var response = await RequestHelper.postJsonAndSpin(Magazine2.requestUrl, Magazine2.requestDto);
			Magazine2.processResponse(response);
			Magazine2.isLoading = false;
		}
	}

	protected static processResponse(res: IResponse) {
		if (!res.requestError) {
			var response = <IResponseWithData<MagazineHomeResponseDto>>res;
			var responseDto = <MagazineHomeResponseDto>response.data;
			if (responseDto.hero != null) {
				Magazine2.renderHero(responseDto.hero);
			}
			if (responseDto.entries.length > 0) {
				var data = responseDto.entries;
				Magazine2.appendData(data);
			}			
		} else {
			Magazine2.errorRenderer.render();
		}

		ImageOverlayHelper.init();
	}
}